import styled from 'styled-components'
import { FaArrowCircleDown, FaArrowCircleUp, FaRegTrashAlt } from 'react-icons/fa'
import { motion } from 'framer-motion'
import { css } from 'styled-components'


const Badge = styled.div`
	color: #fff !important;
	padding: 5px 10px;
	border-radius: 10px;
	background: ${(props) => (props.type === 'buy' ? '#4b652e' : '#853a1d')};
`

const TextWithMargin = styled.div`
	color: ${(props) =>
		((props.type === 'sell' || props.type === 'withdraw') && props.theme.mainRed) ||
		props.theme.mainGreen};
	font-size: inherit;
	margin: 0 ${(props) => ((props.type === 'sell' || props.theme.english) && '8px') || '13px'};
	margin-bottom: ${(props) => !props.theme.english && '-3px'};
`

const Market = styled.div`
	font-size: 0.85rem;
	font-weight: 600;
	letter-spacing: 1.2px;
	margin: 0 5px;
	color: ${(props) => props.theme.color};
`

const BuyIcon = styled(FaArrowCircleUp)`
	color: ${(props) => props.theme.mainGreen};
	size: 14;
	filter: drop-shadow(0 0 4px ${(props) => props.theme.mainGreen});
`

const SellIcon = styled(FaArrowCircleDown)`
	color: ${(props) => props.theme.mainRed};
	size: 14;
	filter: drop-shadow(0 0 4px ${(props) => props.theme.mainRed});
`

const DeleteIcon = styled(FaRegTrashAlt)`
	color: ${(props) => props.theme.color};
	size: 14;
	cursor: pointer;
`

const TableWrapper = styled(motion.div)`
	width: 100%;
	height: ${(props) => props.height || '65%'};
	overflow-y: auto;
	display: flex;

	&::-webkit-scrollbar {
		display: none;
	}

	@media screen and (max-width: 960px) {
		flex-direction: column;
	}
`

const OrdersTab = styled.div`
	position: relative;
	display: flex;
	justify-content: center;
	align-items: center;
	width: 120px;
	height: 70px;
	transition: all 0.5s;
	cursor: pointer;
	
	${({ active }) => active && css`
		border-bottom: 2px solid ${props => props.theme.mainOrange}80;
		background-image: ${({ theme }) => `linear-gradient(45deg, ${theme.tradeBg} 50%, ${theme.mainOrange}10)`};
	`};
	
	@media screen and (max-width: 1050px) {
		height: 50px;
	};
`

const OrdersBody = styled.div`
	width: 100%;
	padding: 10px 15px;
	height: 100%;
`

const Table = styled.div`
  position: relative;
  width: ${props => props.width || "50%"};
`;

const Row = styled.div`
  display: flex;
  width: 100%;
  padding: 0 10px;
  margin: 5px 0;
  color: ${(props) =>
	(props.header && props.header.secondary) || props.theme.color};
  background-color: ${(props) => props.header && props.header.bg_second};
  text-align: ${(props) => props.textAlign};
  font-weight: ${(props) => props.header && 600};
  font-size: ${(props) => props.header && "0.85rem"};
  &:nth-child(even) {
    background-color: ${(props) => props.theme.bg_second};
  }
`;


const HeaderRow = styled.div`
  width: ${props => props.width || "100%"};
  padding: 0 10px;
  margin: 5px 0;
  display: flex;
  color: ${(props) => props.theme.secondary};
  font-weight: 600;
  font-size: ${props => props.fontSize || "0.7rem"};
`;

const HeaderColumn = styled.div`
  width: ${props => props.width || "11.1%"};
  color: ${props => props.theme.color};
  padding: 12px 8px;
  text-align: center;
  font-size: ${props => props.fontSize || "0.7rem"};
  border-bottom: solid 1px ${props => props.theme.color}10;

  @media screen and (max-width: 768px){
    font-size: 0.7rem;
    padding: 10px 8px;
  }
`;

const Column = styled.div`
  transition: all 0.3s;
  padding: 12px 8px;
  width: ${props => props.width || "11%"};
  color: ${(props) => props.color};
  text-align: center;
  font-size: 0.8rem;
	font-family: ${props => props.number && "monospace"};

  @media screen and (max-width: 768px){
    font-size: 0.7rem;
    padding: 10px 8px;
  }
`;

const NoDataWrapper = styled.div`
  display: flex;
  position: absolute;
  top: ${props => props.top || "300px"};
  width: 100%;
  text-align: center;
  justify-content: center;
`;

const FilterWrapper = styled.div`
	display: flex;
	justify-content: flex-start;
	align-items: center;
	width: ${props => props.width};
	height: ${props => props.height};
	
	@media screen and (max-width: 1050px) {
		flex-direction: column;
		align-items: flex-start;
	}
`

const HistoryBody = styled.div`
	height: calc(100% - 80px);
	
	@media screen and (max-width: 1050px) {
		height: calc(100% - 50px);
	};
`

const CancelOrderBtn = styled.div`
	color: ${props => props.theme.color};
	background-color: ${props => props.theme.tInputBg};
	border-radius: 4px;
	padding: 4px 8px;
`

export {
	Badge, Market,
	TextWithMargin, BuyIcon,
	SellIcon, TableWrapper,
	DeleteIcon, OrdersTab,
	OrdersBody, Table,
	Row, Column,
	HeaderRow, HeaderColumn,
	NoDataWrapper,
	FilterWrapper,
	HistoryBody,
	CancelOrderBtn
}
